// extracted by mini-css-extract-plugin
module.exports = {"form":"_6AnG9W"};